module.exports = __webpack_public_path__ + "img/info_3.1673e578.jpeg";